/* eslint-disable */
import Pusher from "pusher-js"
const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    encrypted: true
});

const state = {
    RefreshRoomData: false,
    NEW_NUM_UNREAD_MESSAGE_ROOM_Data: {},
    RemoveRoomData: {
        "room_id": '',
        "agent_id": '',
    },
    NEW_UNREAD_MESSAGE_ROOM_Data: [],
    SCAN_QRCODE_Data: {},
    BATTERY_MESSAGE_Data: {},
    BATTERY_MESSAGE_Min: 15, //15% akan tampil
};

const mutations = {
    SET_RefreshRoom_Data: (state, value) => {
        state.RefreshRoomData = value;
    },
    SET_RemoveRoom_Data: (state, value) => {
        state.RemoveRoomData = value;
    },
    SET_NEW_NUM_UNREAD_MESSAGE_ROOM_Data: (state, value) => {
        state.NEW_NUM_UNREAD_MESSAGE_ROOM_Data = value;
    },
    SET_NEW_UNREAD_MESSAGE_ROOM_Data: (state, value) => {
        state.NEW_UNREAD_MESSAGE_ROOM_Data = value;
    },
    SET_SCAN_QRCODE_Data: (state, value) => {
        state.SCAN_QRCODE_Data = value;
    },
    SET_BATTERY_MESSAGE_Data: (state, value) => {
        state.BATTERY_MESSAGE_Data = value;
    },
};

const actions = {
    UpdateRefreshRoomData({ commit }, value) {
        commit("SET_RefreshRoom_Data", value);
    },
    RefreshRoom_UNSUB({ commit }, dataParams) {
        let sub = dataParams.license_id + "_" + dataParams.id //license_id + agent id
        pusher.unsubscribe(sub)
    },
    RefreshRoom({ commit }, dataParams) {
        let sub = dataParams.license_id + "_" + dataParams.id //license_id + agent id
        let channel = pusher.subscribe(sub)
        console.log("dataa RefreshRoom:sub", sub)

        channel.bind('RefreshRoom', (data) => {
            commit("SET_RefreshRoom_Data", data);
        })

        channel.bind('NEW_NUM_UNREAD_MESSAGE_ROOM', (data) => {
            // console.log("dataa NEW_UNREAD_MESSAGE_ROOM", data)
            commit("SET_NEW_NUM_UNREAD_MESSAGE_ROOM_Data", data);
        })


    },
    NEW_UNREAD_MESSAGE_ROOM({ commit }, dataParams) {
        let sub = dataParams.license_id + "_" + dataParams.room_id + "_MESSAGE"
        // let sub = dataParams.license_id
        console.log("sub", sub)
        let channel = pusher.subscribe(sub)
        // console.log(channel, "NEW_UNREAD_MESSAGE_ROOM")

        channel.bind('NEW_UNREAD_MESSAGE_ROOM', (data) => {
            console.log("dataa NEW_UNREAD_MESSAGE_ROOM_without_agent", data)
            commit("SET_NEW_UNREAD_MESSAGE_ROOM_Data", data);
        })

        let subAgent = dataParams.license_id + "_" + dataParams.id + "_" + dataParams.room_id + "_MESSAGE" //agent id
        console.log("subAgent", subAgent)
        let channelAgent = pusher.subscribe(subAgent)
        channelAgent.bind('NEW_UNREAD_MESSAGE_ROOM', (data) => {
            console.log("dataa NEW_UNREAD_MESSAGE_ROOM_with_agent", data)
            commit("SET_NEW_UNREAD_MESSAGE_ROOM_Data", data);
        })
    },
    NEW_UNREAD_MESSAGE_ROOM_UNSUB({ commit }, dataParams) {
        let sub = dataParams.license_id + "_" + dataParams.room_id + "_MESSAGE"
        console.log("unsub", sub)
        pusher.unsubscribe(sub)

        let subAgent = dataParams.license_id + "_" + dataParams.id + "_" + dataParams.room_id + "_MESSAGE"
        console.log("unsubAgent", sub)
        pusher.unsubscribe(subAgent)

    },
    NEW_NUM_UNREAD_MESSAGE_ROOM({ commit }, dataParams) { //hitung jumlah unread message
        let channel = pusher.subscribe(dataParams.license_id)
        // console.log(channel, "NEW_UNREAD_MESSAGE_ROOM")

        channel.bind('NEW_NUM_UNREAD_MESSAGE_ROOM', (data) => {
            // console.log("dataa NEW_UNREAD_MESSAGE_ROOM", data)
            commit("SET_NEW_NUM_UNREAD_MESSAGE_ROOM_Data", data);
        })

        //remove room
        channel.bind('RemoveRoom', (data) => {
            // console.log("dataa NEW_UNREAD_MESSAGE_ROOM", data)
            commit("SET_RemoveRoom_Data", data);
        })

    },
    SCAN_QRCODE({ commit }, dataParams) {
        // console.log("action puser", dataParams)

        let channel = pusher.subscribe(dataParams.license_id)
        channel.bind('SCAN_QRCODE', (data) => {
            console.log("dataa puser", data)
            commit("SET_SCAN_QRCODE_Data", data);
        })
    },
    SCAN_QRCODE_Unsub({ commit }, dataParams) {
        let channel = pusher.unsubscribe(dataParams.license_id)
        channel.bind('SCAN_QRCODE', (data) => {
            // console.log("dataa puser", data)
            commit("SET_SCAN_QRCODE_Data", data);
        })
    },
    SCAN_QRCODE_DESTROY({ commit }, dataParams) {
        var data = {}
        commit("SET_SCAN_QRCODE_Data", data);
    },
    BATTERY_MESSAGE({ commit }, dataParams) {
        let channel = pusher.subscribe(dataParams.license_id)
        channel.bind('BATTERY_MESSAGE', (data) => {
            // console.log("dataa puser", data)
            commit("SET_BATTERY_MESSAGE_Data", data);
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/pusher copy.js